import { render, staticRenderFns } from "./mini-program-message-release-edit.vue?vue&type=template&id=6267b882"
import script from "./mini-program-message-release-edit.vue?vue&type=script&lang=js"
export * from "./mini-program-message-release-edit.vue?vue&type=script&lang=js"
import style0 from "./mini-program-message-release-edit.vue?vue&type=style&index=0&id=6267b882&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports